module.exports = __webpack_public_path__ + "static/media/map-pin.cc867863.svg";